import { ContactsView } from '@pages/Static';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/contacts')({
  component: ContactsView,
});
